import { ClientLogger } from './client';
import type { Logger } from './types';

const getLogger = (): Logger => {
    if (typeof window === 'undefined') {
        const { ServerLogger } = require('./server');
        return new ServerLogger();
    }
    return new ClientLogger();
};

export const logger = getLogger();
